<div class="modal-header flex-shrink-0 bg-primary text-white">
  <h4 class="modal-title" id="nsis-new-invio-title">Nuova trasmissione dati</h4>
  <button type="button" class="btn-close btn-close-white ms-auto" aria-label="Chiudi modale" (click)="chiudi()"></button>
</div>

<div class="modal-body d-flex flex-column p-3" style="height: 70vh; overflow: hidden;">
  <!-- NAVIGATORE TOP (Cerchi) -->
  <div id="topnavigator" class="topnav-container flex-shrink-0 mb-3 d-flex flex-row flex-nowrap justify-content-evenly align-items-center">
    <div class="circlenumbernav" [style.background-color]="step < 1 ? '#849DB8' : '#093B71'">1</div>
    <div class="fw-bold" [style.color]="step < 1 ? '#849DB8' : '#093B71'">Anno</div>
    <img src="assets/icons/tratto.svg" alt="" aria-hidden="true">
    
    <div class="circlenumbernav" [style.background-color]="step < 2 ? '#849DB8' : '#093B71'">2</div>
    <div class="fw-bold" [style.color]="step < 2 ? '#849DB8' : '#093B71'">ASL</div>
    <img src="assets/icons/tratto.svg" alt="" aria-hidden="true">
    
    <div class="circlenumbernav" [style.background-color]="step < 3 ? '#849DB8' : '#093B71'">3</div>
    <div class="fw-bold" [style.color]="step < 3 ? '#849DB8' : '#093B71'">Ambito</div>
    <img src="assets/icons/tratto.svg" alt="" aria-hidden="true">
    
    <div class="circlenumbernav" [style.background-color]="step < 4 ? '#849DB8' : '#093B71'">4</div>
    <div class="fw-bold" [style.color]="step < 4 ? '#849DB8' : '#093B71'">Sigla</div>
    <img src="assets/icons/tratto.svg" alt="" aria-hidden="true">

    <div class="circlenumbernav" [style.background-color]="step < 5 ? '#849DB8' : '#093B71'">5</div>
    <div class="fw-bold" [style.color]="step < 5 ? '#849DB8' : '#093B71'">Scadenza</div>
    <img src="assets/icons/tratto.svg" alt="" aria-hidden="true">
    
    <div class="circlenumbernav" [style.background-color]="step < 6 ? '#849DB8' : '#093B71'">6</div>
    <div class="fw-bold" [style.color]="step < 6 ? '#849DB8' : '#093B71'">Invia</div>
  </div>

  <!-- SELEZIONI ATTIVE (Badges con X per annullare) -->
  <div id="topnavigator2" class="topnav-selections flex-shrink-0 mb-3 d-flex flex-row flex-nowrap justify-content-start align-items-center" style="min-height: 45px;">
    
    <div class="badge position-relative badge-selection text-primary" *ngIf="annoSel">
      Anno: <span>{{ annoSel }}</span>
      <span class="position-absolute top-0 start-100 translate-middle badge rounded-circle bg-primary border border-2 border-white d-flex align-items-center justify-content-center badge-close"
        (click)="cancellaAnno()" [ngbTooltip]="'Clicca per rimuovere'"> <i class="bi bi-x" style="color:white; font-size: 1rem; padding-bottom: 3px; padding-right: 1px;">x</i> </span>
    </div>
    
    <div class="badge position-relative badge-selection text-primary" *ngIf="aslSel">
      ASL: <span>{{ aslSel.codiceAzienda }}</span>
      <span class="position-absolute top-0 start-100 translate-middle badge rounded-circle bg-primary border border-2 border-white d-flex align-items-center justify-content-center badge-close"
        (click)="cancellaASL()" [ngbTooltip]="'Clicca per rimuovere'"> <i class="bi bi-x" style="color:white; font-size: 1rem; padding-bottom: 3px; padding-right: 1px;">x</i> </span>
    </div>
    
    <div class="badge position-relative badge-selection text-primary" *ngIf="flussoSel">
      Ambito: <span>{{ flussoSel.nome }}</span>
      <span class="position-absolute top-0 start-100 translate-middle badge rounded-circle bg-primary border border-2 border-white d-flex align-items-center justify-content-center badge-close"
        (click)="cancellaFlusso()" [ngbTooltip]="'Clicca per rimuovere'"> <i class="bi bi-x" style="color:white; font-size: 1rem; padding-bottom: 3px; padding-right: 1px;">x</i> </span>
    </div>

    <div class="badge position-relative badge-selection text-primary" *ngIf="siglaSel">
      Sigla: <span>{{ siglaSel }}</span>
      <span class="position-absolute top-0 start-100 translate-middle badge rounded-circle bg-primary border border-2 border-white d-flex align-items-center justify-content-center badge-close"
        (click)="cancellaSigla()" [ngbTooltip]="'Clicca per rimuovere'"> <i class="bi bi-x" style="color:white; font-size: 1rem; padding-bottom: 3px; padding-right: 1px;">x</i> </span>
    </div>
    
    <div class="badge position-relative badge-selection text-primary" *ngIf="periodoSel">
      Scadenza: <span>{{ periodoSel.periodo }}</span>
      <span class="position-absolute top-0 start-100 translate-middle badge rounded-circle bg-primary border border-2 border-white d-flex align-items-center justify-content-center badge-close"
        (click)="cancellaPeriodo()" [ngbTooltip]="'Clicca per rimuovere'"> <i class="bi bi-x" style="color:white; font-size: 1rem; padding-bottom: 3px; padding-right: 1px;">x</i> </span>
    </div>
  </div>

  <!-- AREA LISTE DI SCELTA (Center Navigator) -->
  <div id="centernavigator" class="center-navigator d-flex flex-column justify-content-start align-items-start m-3">
    
    <div *ngIf="loading" class="w-100 text-center p-4">
      <div class="spinner-border text-primary" role="status"></div>
    </div>

    <!-- Step 1: Anno -->
    <div *ngIf="step == 1 && !loading" class="inobox w-100">
      <h3 class="mb-3 text-start">Scegli l'anno</h3>
      <div class="list-group" style="max-height: 310px; max-width: 98%;">
        <button type="button" class="list-group-item list-group-item-action text-start fw-bold text-primary"
          *ngFor="let aa of anni" (click)="chooseAnno(aa)">{{ aa }}</button>
      </div>
    </div>

    <!-- Step 2: ASL -->
    <div *ngIf="step == 2 && !loading" class="inobox w-100">
      <h3 class="mb-3 text-start">Scegli la ASL</h3>
      <div class="list-group" style="max-height: 310px; max-width: 98%;">
        <button type="button" class="list-group-item list-group-item-action text-start fw-bold text-primary"
          *ngFor="let asl of aslList" (click)="chooseAsl(asl)">{{ asl.denominazioneAzienda }}</button>
      </div>
    </div>

    <!-- Step 3: Flusso/Ambito -->
    <div *ngIf="step == 3 && !loading" class="inobox w-100">
      <h3 class="mb-3 text-start">Scegli l'ambito</h3>
      <div class="list-group" style="max-height: 310px; max-width: 98%;">
        <button type="button" class="list-group-item list-group-item-action text-start fw-bold text-primary"
          *ngFor="let f of flussiMostrati" (click)="chooseFlusso(f)">{{ f.nome }}</button>
      </div>
    </div>

    <!-- Step 4: Sigla -->
    <div *ngIf="step == 4 && !loading" class="inobox w-100">
      <h3 class="mb-3 text-start">Scegli la sigla</h3>
      <div *ngIf="missingScadenzeMessage" class="alert alert-warning m-2 text-start">
        <i class="bi bi-exclamation-triangle-fill me-2"></i> {{missingScadenzeMessage}}
      </div>
      <div class="list-group" style="max-height: 310px; max-width: 98%;">
        <button type="button" class="list-group-item list-group-item-action text-start fw-bold text-primary"
          *ngFor="let sigla of sigleDisponibili" (click)="chooseSigla(sigla)">{{ sigla }}</button>
      </div>
    </div>

    <!-- Step 5: Scadenza -->
    <div *ngIf="step == 5 && !loading" class="inobox w-100">
      <h3 class="mb-3 text-start">Scegli la scadenza</h3>
      <div *ngIf="missingScadenzeMessage" class="alert alert-warning m-2 text-start">
        <i class="bi bi-exclamation-triangle-fill me-2"></i> {{missingScadenzeMessage}}
      </div>
      <div class="list-group" style="max-height: 310px; max-width: 98%;">
        <button type="button" class="list-group-item list-group-item-action text-start fw-bold text-primary"
          *ngFor="let sc of scadenzeDisponibili" (click)="choosePeriodo(sc)">
          ID: {{ sc.id_scadenza }} | Periodo: {{ sc.periodo }} | Data scadenza: {{ sc.data_scadenza_ministeriale | date:'dd/MM/yyyy' }}
        </button>
      </div>
    </div>

    <!-- Step 6: Riepilogo & Invio -->
    <div *ngIf="step == 6 && !loading" class="inobox w-100 align-items-center">
      <h3 class="mb-4">Riepilogo Estrazione Dati</h3>

      <div *ngIf="!isIcd10FlowSelected" class="mb-3">
        Dati estratti: 
        <span class="badge bg-secondary fs-6 mx-1">{{anagrafiche}}</span> anagrafiche,
        <span class="badge bg-secondary fs-6 mx-1">{{contatti}}</span> contatti,
        <span class="badge bg-secondary fs-6 mx-1">{{prestazioni}}</span> {{stringPre}}
      </div>

      <div *ngIf="isIcd10FlowSelected" class="mb-3">
        Dati estratti: <span class="badge bg-secondary fs-6 mx-1">{{contatti}}</span> contatti con ICD10.
      </div>
      
      <div class="mb-3">
        Scadenza Selezionata: 
        <span class="badge bg-secondary fs-6 ml-2" [ngClass]="idIstanzaFlussoInbound !== 0 ? 'bg-primary' : 'bg-danger'">
          ID: {{idIstanzaFlussoInbound}} | Data scadenza: {{dataScadenzaFlusso ? (dataScadenzaFlusso | date:'dd/MM/yyyy') : 'Assente'}} 
        </span>
      </div>

      <div *ngIf="isIcd10FlowSelected" class="mb-3">
        Verifica invio standard:
        <span class="badge fs-6 ml-2" [ngClass]="standardFlowHistoryExists ? 'bg-primary' : 'bg-danger'" style="white-space: normal; text-align: left;">
          {{standardFlowHistoryExists ? 'Invio standard presente nello storico: accertarsi che sia stato elaborato correttamente in piattaforma flussi' : 'Invio standard con esito positivo assente nello storico'}}
        </span>
      </div>
      
      <div *ngIf="missingScadenzeMessage" class="alert alert-warning mt-3 w-75 font-weight-bold text-start">
        <i class="bi bi-exclamation-triangle-fill me-2"></i> {{missingScadenzeMessage}}
      </div>
      
      <div *ngIf="resultInvii.length > 0" class="mt-4 w-100">
        <div *ngFor="let res of resultInvii">
          
          <!-- Caso di Errore -->
          <div *ngIf="!res.esito && !res.successo" class="alert alert-danger font-weight-bold text-start">
            <i class="bi bi-x-circle-fill me-2"></i> Errore: {{res.messaggio || res.message}}
          </div>
          
          <!-- Caso di Successo -->
          <div *ngIf="res.esito || res.successo" class="alert alert-success font-weight-bold text-start">
            <i class="bi bi-check-circle-fill me-2"></i> Trasmissione avvenuta con successo!
          </div>
          
        </div>
      </div>

      <div class="mt-4" *ngIf="resultInvii.length === 0">
        <button class="btn btn-primary fw-bold" (click)="inviaRegione(dataRifDa, dataRifA)" [disabled]="!canInviaDati || loadingInvio">
          <span *ngIf="loadingInvio"></span>
          Invia dati selezionati in piattaforma
        </button>
      </div>

    </div>
  </div>
</div>

<div class="modal-footer justify-content-end flex-shrink-0 bg-light">
  <button type="button" class="btn btn-outline-secondary" (click)="chiudi(resultInvii.length > 0)">
    {{resultInvii.length > 0 ? 'Chiudi e aggiorna' : 'Annulla'}}
  </button>
</div>